export const COURSE = '/course/create'
export const COURSE_CREATE = `${COURSE}/create`
